export const getKpiStatus = (value) => {
    if (value >= 1.05) return 'green';
    if (value >= 0.95) return 'amber';
    return 'red';
};

export const STATUS_COLOR = { green: '#22C55E', amber: '#F59E0B', red: '#EF4444' };

export const getKpiInsight = (kpi, value, sourceData) => {
    const status = getKpiStatus(value);

    if (kpi === 'cpi') {
        const insight =
            value >= 1.05
                ? `For every $1 spent, $${value.toFixed(2)} of value is earned — under budget`
                : value >= 0.95
                ? `For every $1 spent, $${value.toFixed(2)} of value is earned — on track`
                : `Spending ${((1 - value) * 100).toFixed(1)}% more than the value being earned — cost overrun`;
        return {
            status,
            label: 'CPI',
            title: 'CPI — Cost Performance Index',
            description: 'Measures cost efficiency. How much value is earned per dollar spent.',
            insight,
            formula: 'EV / AC',
            components: [
                { key: 'ev', label: 'EV', value: sourceData?.ev, note: 'value earned', type: 'currency' },
                { key: 'ac', label: 'AC', value: sourceData?.ac, note: 'actual cost', type: 'currency' },
            ],
        };
    }

    if (kpi === 'ler') {
        const insight =
            value >= 1.05
                ? `${((value - 1) * 100).toFixed(1)}% more efficient than planned — labor under budget`
                : value >= 0.95
                ? `Hours consumed are aligned with forecast — labor on track`
                : `Consuming ${((1 - value) * 100).toFixed(1)}% more hours than forecasted — labor over budget`;
        return {
            status,
            label: 'LER',
            title: 'LER — Labor Efficiency Ratio',
            description: 'Measures labor efficiency. Forecast hours vs actual hours burned for this period.',
            insight: '',
            formula: 'ForecastHours / ActualHours',
            components: [
                { key: 'forecastHours', label: 'For. Hours', value: sourceData?.forecastHours, note: 'forecast hours', type: 'number' },
                { key: 'actualHours', label: 'Act. Hours', value: sourceData?.actualHours, note: 'actual hours', type: 'number' },
            ],
        };
    }

    return null;
};
